export const HELSEKONTAKTER_PATH = '/helsekontakter';
export const FASTLEGEN_PATH = '/fastlegen';
export const FASTLEGE_TJENESTER_PATH = '/fastlege-tjenester';
